export default __webpack_public_path__ + "static/media/sms.5699a829.png";